import { z } from 'zod'

const GeoJSONPositionSchema = z.number().array()
export type GeoJSONPosition = z.infer<typeof GeoJSONPositionSchema>

export const GeoJSONPointSchema = z.object({
  type: z.literal('Point'),
  coordinates: GeoJSONPositionSchema,
})
export type GeoJSONPoint = z.infer<typeof GeoJSONPointSchema>

export const GeoJSONMultiPointSchema = z.object({
  type: z.literal('MultiPoint'),
  coordinates: GeoJSONPositionSchema.array(),
})
export type GeoJSONMultiPoint = z.infer<typeof GeoJSONMultiPointSchema>

export const GeoJSONPolygonSchema = z.object({
  type: z.literal('Polygon'),
  coordinates: GeoJSONPositionSchema.array().array(),
})
export type GeoJSONPolygon = z.infer<typeof GeoJSONPolygonSchema>

export const GeoJSONMultiPolygonSchema = z.object({
  type: z.literal('MultiPolygon'),
  coordinates: GeoJSONPositionSchema.array().array().array(),
})
export type GeoJSONMultiPolygon = z.infer<typeof GeoJSONMultiPolygonSchema>
